import { cloneElement } from "react";

export type ComposeProps = {
  providers: React.ReactElement[];
};

export function Compose({ providers, children }: React.PropsWithChildren<ComposeProps>) {
  return <>{providers.reduceRight((child, parent) => cloneElement(parent, {}, child), children)}</>;
}
